<template>
  <div class="pages">
    <navTop></navTop>
    <!-- 标题 -->
    <div class="title">
      <span>{{ details.serveTitle }}</span>
    </div>
    <div class="box">
      <!-- 信息 -->
      <div class="information">
        <div class="information-item item1">
          <p class="item-title">
            <span></span>
            <span>{{ details.name }}</span>
            <span>Free</span>
          </p>
          <ul>
            <li>
              <span>Price</span>
              <span>${{ parseInt(details.price) }}</span>
            </li>
            <li>
              <span>Order number</span>
              <span>{{ details.counts || 0 }}</span>
            </li>
            <li>
              <span>Service</span>
              <span v-if="details.serveType == 0"
                >Pre-loading / Discharging Survey</span
              >
              <span v-if="details.serveType == 1"
                >On/Off Hire Bunker Survey/Bunker & Condition Survey</span
              >
              <span v-if="details.serveType == 2">Bunkering Survey</span>
              <span v-if="details.serveType == 3">Draft Survey</span>
            </li>
            <li>
              <span>Entire period of actual operation</span>
              <span>{{ details.workYear }}year</span>
            </li>
          </ul>
        </div>
        <div class="information-item item1">
          <p class="item-title">
            <span></span>
            <span>Order information</span>
            <span @click="show = true">Modify</span>
          </p>
          <ul>
            <li>
              <span>Full name</span>
              <span>{{ details.username }}</span>
            </li>
            <li>
              <span>Cell-phone number</span>
              <span>{{ details.phone }}</span>
            </li>
            <li>
              <span>Corporate name</span>
              <span>{{ details.company }}</span>
            </li>
            <li>
              <span>Company address</span>
              <span>{{ details.address }}</span>
            </li>
          </ul>
        </div>

        <div class="information-item item2">
          <p class="item-title">
            <span></span>
            <span>Detailed information</span>
            <span></span>
          </p>
          <textarea
            placeholder="Please enter details"
            v-model="information"
          ></textarea>
        </div>
        <div class="information-item item2">
          <p class="item-title">
            <span></span>
            <span>Remarks</span>
            <span></span>
          </p>
          <textarea
            placeholder="Please enter comments"
            v-model="remarks"
          ></textarea>
        </div>
      </div>
      <!-- 下拉框 -->
      <select @change="selectService($event)">
        <option v-for="item in details.workArea.split(',')">{{ item }}</option>
      </select>
      <!-- 他的日期 -->
      <div class="hisDate">
        <p class="hisDate-title">His date</p>
        <calendar
          :gzList="details.dateWorkArg"
          :xxList="details.dateRestArg"
          :yxList="details.workDate"
          @val="fnVal"
        ></calendar>
      </div>
      <!-- 具体开始时间 -->
      <div class="time">
        <span>Specific start time</span>
        <el-date-picker
          v-model="time"
          type="datetime"
          :editable="false"
          :format="'yyyy-MM-dd HH:mm:ss'"
          :clearable="false"
          placeholder="Select time"
          :picker-options="pickerOptions"
        ></el-date-picker>
      </div>
      <!-- 立即下单 -->
      <div class="ordernow" @click="goPay">Order now</div>
    </div>
    <navFooter></navFooter>
    <!-- 修改框 -->
    <el-dialog
      :visible.sync="show"
      :width="'460px'"
      :show-close="false"
      :close-on-click-modal="false"
    >
      <div class="dialog-title">Personal information</div>
      <li class="dialog-li">
        <input
          type="text"
          v-model="details.username"
          placeholder="Please enter your name"
        />
        <img
          v-if="details.username.length > 0"
          @click="details.username = ''"
          src="../../assets/del.png"
          alt=""
        />
      </li>
      <li class="dialog-li">
        <input
          type="text"
          v-model="details.company"
          placeholder="Please enter your company"
        />
        <img
          v-if="details.company.length > 0"
          @click="details.company = ''"
          src="../../assets/del.png"
          alt=""
        />
      </li>
      <li class="dialog-li">
        <input
          type="text"
          v-model="details.address"
          placeholder="Please enter your address"
        />
        <img
          v-if="details.address.length > 0"
          @click="details.address = ''"
          src="../../assets/del.png"
          alt=""
        />
      </li>
      <li class="dialog-li">
        <input
          type="text"
          @input="details.phone = details.phone.replace(/[^\d]/g, '')"
          maxlength="11"
          v-model="details.phone"
          placeholder="Please enter your mobile phone number"
        />
        <img
          v-if="details.phone.length > 0"
          @click="details.phone = ''"
          src="../../assets/del.png"
          alt=""
        />
      </li>
      <div class="dialog-btn" @click="edit">Preservation</div>
    </el-dialog>
  </div>
</template>

<script>
import navTop from "../../components/navTop.vue";
import navFooter from "../../components/navFooter.vue";
import calendar from "../../components/calendar.vue";
export default {
  name: "placeOrder",
  components: {
    navTop,
    navFooter,
    calendar,
  },
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        },
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
          {
            text: "明天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
          {
            text: "一周后",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
        ],
      },
      details: {}, //下单数据
      show: false, //修改框状态
      information: "", //详细信息
      remarks: "", //备注
      calendarList: [],
      service: "",
      time: "",
    };
  },
  created() {
    if (!sessionStorage.getItem("uid")) {
      this.$router.push({ path: "/" });
    } else {
      let obj = JSON.parse(this.$route.query.obj);

      let servePic = [];
      if (typeof obj.servePic == "string" && obj.servePic.length != 0) {
        servePic = obj.servePic.split("|");
      }
      if (typeof obj.servePic == "object") {
        servePic = obj.servePic;
      }
      console.log(obj);
      this.details = {
        docId: obj.docId,
        serveId: obj.serveId,
        serveTitle: obj.serveTitle,
        name: obj.name,
        price: obj.price,
        serveType: obj.serveType,
        counts: obj.counts,
        workYear: obj.workYear,
        workDate: JSON.parse(obj.workDate),
        workArea: obj.workArea,
        username: JSON.parse(sessionStorage.getItem("infoList")).name,
        phone: JSON.parse(sessionStorage.getItem("infoList")).phone,
        company: JSON.parse(sessionStorage.getItem("infoList")).company,
        address: JSON.parse(sessionStorage.getItem("infoList")).address,
        dateWorkArg: obj.dateWorkArg,
        dateRestArg: obj.dateRestArg,
        // servePic: obj.servePic ? obj.servePic.split("|") : [],
        servePic: servePic,
        appraiseStar: obj.appraiseStar,
      };
      this.service = obj.workArea.split(",")[0];
      console.log(this.details);
    }
  },
  methods: {
    edit() {
      if (this.details.username == "") {
        this.details.username = JSON.parse(
          sessionStorage.getItem("infoList")
        ).name;
      }
      if (this.details.phone == "") {
        this.details.phone = JSON.parse(
          sessionStorage.getItem("infoList")
        ).phone;
      }
      if (this.details.company == "") {
        this.details.company = JSON.parse(
          sessionStorage.getItem("infoList")
        ).company;
      }
      if (this.details.address == "") {
        this.details.address = JSON.parse(
          sessionStorage.getItem("infoList")
        ).address;
      }
      this.show = false;
    },
    // 接收选择日期
    fnVal(val) {
      console.log(val)
      this.calendarList = val;
    },
    // 选择服务
    selectService(e) {
      this.service = e.target.value;
    },
    // 转化时间
    formatDateTime(date) {
      let y = date.getFullYear();
      let m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      let minute = date.getMinutes();
      minute = minute < 10 ? "0" + minute : minute;
      let second = date.getSeconds();
      second = second < 10 ? "0" + second : second;
      return y + "-" + m + "-" + d + " " + h + ":" + minute + ":" + second;
    },
    // 立即下单
    goPay() {
      if (this.information == "") {
        this.$message({
          message: "Details cannot be empty",
          type: "error",
          center: true,
          duration: 1000,
        });
        return;
      }
      if (this.time == "") {
        this.$message({
          message: "Please select a specific start time",
          type: "error",
          center: true,
          duration: 1000,
        });
        return;
      }

      let workDate = [];
      this.calendarList.forEach((item) => {
        workDate.push(item.day);
      });
      if (workDate.length == 0) {
        this.$message({
          message: "Please select working days",
          type: "error",
          center: true,
          duration: 1000,
        });
        return;
      }
      let data = {
        uid: sessionStorage.getItem("uid"),
        docId: this.details.docId,
        serveId: this.details.serveId,
        serveType: this.details.serveType,
        workDate: workDate.join(","),
        startTime: this.formatDateTime(this.time),
        name: this.details.username,
        phone: this.details.phone,
        company: this.details.company,
        address: this.details.address,
        city: this.service,
        detail: this.information,
        remarks: this.remarks,
        price: workDate.length * Number(this.details.price),
        servePic: this.details.servePic ? this.details.servePic.join("|") : "",
        appraiseStar: this.details.appraiseStar,
      };
      this.$api.create(data).then((res) => {
        console.log(res);
        if (res.result == 0) {
          this.$router.push({
            path: "/pay",
            query: {
              id: res.data.orderId,
              sum: res.data.sum,
              title: this.details.serveTitle,
              serveType: this.details.serveType,
              num: 1,
            },
          });
        } else {
          this.$message({
            message: res.resultNote,
            type: "error",
            center: true,
            duration: 1000,
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.pages {
  background: #3E414A;
  .box {
    // 信息
    .information {
      margin-top: 36px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-around;
      .information-item {
        width: 695px;
        background-image: url(../../assets/details-items.png);
        background-size: 100% 100%;
        border-radius: 21px;
        margin-bottom: 55px;
        .item-title {
          padding: 30px 51px 0 37px;
          box-sizing: border-box;
          display: flex;
          justify-content: space-between;
          align-items: center;
          span:nth-child(1) {
            display: block;
            width: 70px;
          }
          span:nth-child(2) {
            font-size: 33px;
            color: #00fff0;
            line-height: 1em;
          }
          span:nth-child(3) {
            display: block;
            width: 70px;
            text-align: center;
            font-size: 22px;
            color: #1bf6ff;
            line-height: 1em;
          }
        }
      }
      .item1 {
        padding: 0px 40px 60px 53px;
        box-sizing: border-box;
        ul {
          padding: 41px 30px 0 30px;
          box-sizing: border-box;
          li {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 19px;
            span:nth-child(1) {
              font-size: 27px;
              color: #e3fffd;
              line-height: 1em;
              margin-right: 18px;
            }
            span:nth-child(2) {
              flex: 1;
              display: inline-block;
              font-size: 27px;
              color: #00fff0;
              line-height: 1em;
              text-align: right;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
          }
        }
      }
      .item2 {
        padding: 0 40px 60px 53px;
        box-sizing: border-box;
        .text {
          padding: 35px 43px 0 33px;
          box-sizing: border-box;
          font-size: 26px;
          color: #e3fffd;
          line-height: 36px;
        }
        textarea {
          width: 100%;
          height: 211px;
          background: rgba(35, 254, 246, 0.1);
          border: 1px solid #48ece7;
          outline: none;
          resize: none;
          padding: 17px 20px;
          box-sizing: border-box;
          font-weight: 400;
          color: #13fffc;
          line-height: 28px;
          margin-top: 35px;
        }
        textarea::-webkit-input-placeholder {
          color: #13fffc;
        }
      }
    }
    // 下拉框
    select {
      width: 100%;
      height: 70px;
      border: 1px solid rgba(0, 250, 255, 0.6);
      border-radius: 10px;
      outline: none;
      background: #002f35;
      padding: 0 77px;
      box-sizing: border-box;
      font-size: 26px;
      color: #00fff0;
      margin-bottom: 56px;
      option {
        background: #000;
        color: #00d9dd;
      }
    }
    // 他的日期
    .hisDate {
      width: 100%;
      border-radius: 45px;
      background-image: url(../../assets/details-case.png);
      background-size: 100% 100%;
      padding: 0 87px 100px 114px;
      box-sizing: border-box;
      .hisDate-title {
        text-align: center;
        color: #ffffff;
        padding: 100px 0;
        box-sizing: border-box;
        font-size: 60px;
      }
    }
    // 时间
    .time {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: flex-start;
      margin-top: 30px;
      span {
        color: #00d9dd;
        font-size: 26px;
        line-height: 1em;
        margin-bottom: 20px;
      }
      ::v-deep .el-input {
        width: 100%;
        .el-input__inner {
          height: 50px;
          background: #000;
          padding: 0 20px;
          box-sizing: border-box;
          border: 1px solid #48ece7;
          color: #00d9dd;
          font-size: 26px;
        }
        .el-input__prefix {
          display: none;
        }
        .el-input__suffix {
          display: none;
        }
        input::-webkit-input-placeholder {
          color: rgba(19, 255, 252, 1);
        }
        input:-moz-placeholder {
          color: rgba(19, 255, 252, 1);
        }
        input::-moz-placeholder {
          color: rgba(19, 255, 252, 1);
        }
        input::-ms-input-placeholder {
          color: rgba(19, 255, 252, 1);
        }
      }
    }
    // 立即下单
    .ordernow {
      width: 728px;
      height: 104px;
      background: linear-gradient(
        90deg,
        rgba(29, 175, 170, 0.8) 0%,
        rgba(35, 254, 246, 0.8) 100%
      );
      margin: 61px auto;
      font-size: 36px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #f6f6f6;
      line-height: 104px;
      text-align: center;
    }
  }
  .title {
    width: 100%;
    height: 131px;
    background-image: url(../../assets/details-title.png);
    background-size: 100% 100%;
    margin-top: 50px;
    span {
      width: 100%;
      height: 87px;
      display: block;
      text-align: center;
      font-size: 40px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #00fcff;
      line-height: 87px;
      padding-right: 70px;
      box-sizing: border-box;
    }
  }
}
::v-deep .el-dialog__wrapper {
  .el-dialog {
    height: 577px;
    background-image: url(../../assets/place-order-edit.png);
    background-size: 100% 100%;
    .el-dialog__header {
      display: none;
    }
    .el-dialog__body {
      padding: 31px 42px 80px 38px;
      box-sizing: border-box;
      .dialog-title {
        font-size: 30px;
        font-family: Adobe Heiti Std;
        font-weight: normal;
        color: #06fffd;
        text-align: center;
        line-height: 1em;
        margin-bottom: 5px;
      }
      .dialog-li {
        height: 71px;
        border-bottom: 1px solid #06fffd;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        input {
          width: 100%;
          height: 69px;
          background: #060c18;
          border: none;
          font-size: 14px;
          outline: none;
          color: #13fffc;
          padding: 0 6px;
          box-sizing: border-box;
        }
        img {
          width: 16px;
          height: 16px;
          display: block;
        }
      }
      .dialog-btn {
        width: 100%;
        height: 60px;
        background: linear-gradient(
          90deg,
          rgba(26, 175, 170, 0.8) 0%,
          rgba(29, 255, 247, 0.8) 100%
        );
        margin-top: 83px;
        font-size: 24px;
        font-weight: bold;
        color: #f6f6f6;
        line-height: 60px;
        text-align: center;
      }
    }
  }
}
</style>
